// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2a22a250","topRow":"_1d830102","title":"_12847643","bottomRow":"_33e80f26","link":"_f093d9e3","background":"_fdf7220d","shimmerLoadingBackground":"_75f221ae"};